export default __webpack_public_path__ + "static/media/ziraatbank.c18d3c34.png";